<template>
  <svg
    width="15"
    height="16"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 4C12 4 9.75 0 6 0C2.25 0 0 4 0 4C0 4 2.25 8 6 8C9.75 8 12 4 12 4ZM0.87975 4C1.24239 4.53445 1.65948 5.03223 2.12475 5.48582C3.09 6.42327 4.41 7.27273 6 7.27273C7.59 7.27273 8.90925 6.42327 9.876 5.48582C10.3413 5.03223 10.7584 4.53445 11.121 4C10.7584 3.46554 10.3413 2.96777 9.876 2.51418C8.90925 1.57673 7.58925 0.727273 6 0.727273C4.41 0.727273 3.09075 1.57673 2.124 2.51418C1.65873 2.96777 1.24164 3.46554 0.879 4H0.87975Z"
      fill="#696F79"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 2.18235C5.50272 2.18235 5.02581 2.37391 4.67417 2.71488C4.32254 3.05586 4.125 3.51832 4.125 4.00053C4.125 4.48274 4.32254 4.94521 4.67417 5.28618C5.02581 5.62716 5.50272 5.81871 6 5.81871C6.49728 5.81871 6.97419 5.62716 7.32583 5.28618C7.67746 4.94521 7.875 4.48274 7.875 4.00053C7.875 3.51832 7.67746 3.05586 7.32583 2.71488C6.97419 2.37391 6.49728 2.18235 6 2.18235ZM3.375 4.00053C3.375 3.32544 3.65156 2.67799 4.14384 2.20062C4.63613 1.72326 5.30381 1.45508 6 1.45508C6.69619 1.45508 7.36387 1.72326 7.85616 2.20062C8.34844 2.67799 8.625 3.32544 8.625 4.00053C8.625 4.67563 8.34844 5.32308 7.85616 5.80044C7.36387 6.27781 6.69619 6.54599 6 6.54599C5.30381 6.54599 4.63613 6.27781 4.14384 5.80044C3.65156 5.32308 3.375 4.67563 3.375 4.00053Z"
      fill="#696F79"
    />
  </svg>
</template>

<script>
export default {
  name: 'GreyOpenedEyeIcon16'
};
</script>

<style scoped>

</style>
